export const listPlansSelector = (state) => state.listPlans.data;
//# sourceMappingURL=selectors.js.map